<form-row *ngIf="formControl">
  <mat-checkbox [formControl]="formControl">
    Hiermit akzeptiere ich die
    <a
      [href]="privacyPolicyUrl$ | async"
      target="_blank"
      style="white-space: nowrap"
      [innerText]="'Datenschutzbestimmungen'"></a>
    <span
      [innerText]="
        ', sowie den Erhalt von angebots- und vertragsbezogenen Informationen über meine angegebenen Kontaktdaten.'
      "></span>
    <mat-error *ngIf="formControl?.invalid && formControl?.touched">
      Bitte akzeptieren Sie die Datenschutzbestimmungen.
    </mat-error>
  </mat-checkbox>
</form-row>
